import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EduIntroTour = class EduFeedback extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-intro-tour';
    }

    constructor(element) {
        super(element);
        this.animated = false;
    }

    render() {
        this.setVars();
        this.setCookie();
        this.setEventListeners();
    }

    setVars() {
        this.introTourVisibilityKey = 'edu_intro_tour_visible';
        this.animated = this.element.dataset.animated === "true" ? true : false;
    }

    setEventListeners(){
        if (this.animated) {
            window.addEventListener('DOMContentLoaded', this.onLoad.bind(this));
        }
    }

    onLoad(){
        this.element.classList.add('is-loaded');
    }

    setCookie() {
        if (this.getCookie(this.introTourVisibilityKey)) return;

        const expiresDate = new Date(new Date().getTime() + 31556926 * 1000);

        document.cookie =
            this.introTourVisibilityKey + '=true; path=/; expires=' + expiresDate.toUTCString();
    }

    getCookie(name) {
        var matches = document.cookie.match(
            new RegExp(
                '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
            )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }
};



// WEBPACK FOOTER //
// ./components/edu-intro-tour/scripts/edu-intro-tour.js